import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ListForm } from '../../../../base/controlers/list-form';
import { DoorType } from '../../models/door-type';
import { InsideType } from '../../models/inside-type';
import { DoorTypeService } from '../../services/door-type.service';
import { InsideTypeService } from '../../services/inside-type.service';

@Component({
  selector: 'app-inside-type-list',
  templateUrl: './inside-type-list.component.html',
  styleUrls: ['./inside-type-list.component.css']
})
export class InsideTypeListComponent extends ListForm<InsideType> implements OnInit {
  public displayedColumns = ['actions','code','name'];
  constructor(
    protected insideTypeService: InsideTypeService,
    protected router:Router
  ) {
    super(insideTypeService,'/plasard-measurement/inside-type',router);
   }

  ngOnInit() {
    super.ngOnInit();
  }

}